import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@dropbox/dig-components/buttons';
import { Modal } from '@dropbox/dig-components/modal';

type Props = {
  showTestMode: boolean;
  setShowTestMode: React.Dispatch<React.SetStateAction<boolean>>;
};

export function TestModeModal({ showTestMode, setShowTestMode }: Props) {
  return (
    <Modal aria-labelledby="test-title" open={showTestMode}>
      <Modal.Header hasBottomSpacing="title-standard">
        <Modal.Title id="test-title">
          <FormattedMessage
            id="a638c306f574f0792a03fd8c8e44824ab60e25ddf93e607a8b22567983f84ca9"
            defaultMessage="This is not legally binding"
            description="pop up message in when accessing preview of signature request, stating that this is not legal binding"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormattedMessage
          id="f4c1ea8b332f926b7bcb7b9175e3d2343f0ece41f25d2637b708d2a87f827eec"
          defaultMessage="This is a mock signature request and has no legal value."
          description="pop up message in when accessing preview of signature request, stating that this is not legal binding"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => setShowTestMode(false)} variant="primary">
          <FormattedMessage
            id="ff06f8554c0d6305a563b01b7877f636c729144f3d88517771b5b528e8ab6a77"
            defaultMessage="OK"
            description="button text in modal in signature request preview page, understood, closes the modal when clicked"
          />
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
